<template>
    <section>
        <div class="grid-container">
            <div class="profile-label grid-item" data-qa="orders-heading">
                Orders
            </div>
        </div>
        <template>
            <div class="money-orders-details">
                <ds-table-grid
                    :data="orders"
                    align="center"
                    :sort-field="sortField"
                    :sort-ascending="sortAscending"
                    :click-row="editOrderModal"
                    @sort="sortTable"
                >
                    <ds-table-grid-column
                        label="Order name"
                        width="130"
                    >
                        <template slot-scope="order">
                            <span :title="order.title">
                                {{ modifyValidationMessage(order.title) }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Payment plan"
                        width="130"
                    >
                        <template slot-scope="order">
                            <span :title="order.payPlanStatus">
                                {{ modifyValidationMessage(order.payPlanStatus) }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Status"
                        width="130"
                    >
                        <template slot-scope="order">
                            <span :title="order.refundStatus">
                                {{ modifyValidationMessage(order.refundStatus) }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Total"
                        width="70"
                    >
                        <template slot-scope="order">
                            <span>
                                {{ order.formattedInvoiceTotal }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Paid"
                        width="70"
                    >
                        <template slot-scope="order">
                            <span>
                                {{ order.formattedTotalPaid }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Balance"
                        width="60"
                    >
                        <template slot-scope="order">
                            <span :class="checkValidMessage(order.currentDuePositive,order.currentDueNegative)">
                                {{ order.formattedCurrentDue }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Remaining balance"
                        width="130"
                    >
                        <template slot-scope="order">
                            <span>
                                {{ order.formattedRemainingBalance }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Date"
                        sortable
                    >
                        <template slot-scope="order">
                            <span>
                                {{ dateFormatDate(order.dueDate, 'MMM D, YYYY') }}
                            </span>
                        </template>
                    </ds-table-grid-column>
                </ds-table-grid>
            </div>

            <div v-if="ordersCount > 10" class="view-all-order-div" data-qa="view-all-orders">
                <span>Showing {{ orders.length }} of {{ ordersCount }}
                    <ds-text-button class="show-all-order-button" data-qa="view-allorder-btn" @click="showModal">
                        Show all order
                    </ds-text-button>
                </span>
            </div>

            <div>
                <contact-money-orders-modal ref="orderModal" :contact="contact" />
            </div>
        </template>
    </section>
</template>

<script>
import moment from 'moment';
import ContactMoneyOrdersModal from './ContactMoneyOrdersModal';

export default {
    components: {
        ContactMoneyOrdersModal,
    },

    props: {
        orders: Array,
        ordersCount: [String, Number],
        contact: Object,
    },

    data() {
        return {
            sortAscending: false,
            sortField: 'dueDate',
        };
    },

    methods: {
        dateFormatDate(date, format = 'll') {
            const formattedDate = moment(date).isValid() ? date : new Date(date);

            return moment(formattedDate).format(format);
        },

        checkValidMessage(positive, negetive) {
            if (positive) {
                return 'order-current-due-positive';
            }

            if (negetive) {
                return 'order-current-due-negative';
            }

            return 'order-current-due-normal';
        },

        modifyValidationMessage(message) {
            message = (message ?? 'N/A') || (message === '' ? 'N/A' : message);

            if (message && message.length > 20) {
                return `${message.slice(0, 20)}...`;
            }

            return message;
        },

        showModal() {
            this.$refs.orderModal.showModal();
        },

        sortTable({ ascending }) {
            const factor = ascending === true ? -1 : 1;

            this.sortAscending = ascending;
            this.orders = this.orders.sort((prev, next) => {
                if (prev.dueDate > next.dueDate) return -1 * factor;
                if (prev.dueDate < next.dueDate) return 1 * factor;

                return 0;
            });
        },

        editOrderModal(order) {
            window.open(`/Job/manageJob.jsp?view=edit&ID=${order.orderId}`);
        },
    },
};

</script>

<style lang="scss" scoped>

.grid-container{
    display: flex;
    margin: $spacing-250 0;
}

.grid-item{
    margin: auto;
}

.profile-label {
    margin-left: 0;
    font-size: 1.75rem;
    color: $color-text;
}

.money-orders-details {
    white-space: nowrap;
    cursor: pointer;
}

.view-all-order-div {
    text-align: center;
    margin-top: 1.75rem;
}

.show-all-order-button {
    padding: 0.4rem;
}

.order-current-due-positive {
    color: $color-red;
}

.order-current-due-negative {
    color: $color-blue;
}
.order-current-due-normal {
    color: $color-gray-dark;
}

@media only screen and ($medium) {
    .grid-container {
        margin-top: 1.875rem;
        display: block;
    }
}
</style>
